<lib-nec-connector-switch [tabsTypes]="cimClassOptions" [allTypes]="allTypes" [activeItemId]="activeItemId"
    (openSubstationSchematic)="openSubstationSchematic.emit($event)">
</lib-nec-connector-switch>
